<template>
  <div>
    <section>
      <v-layout row wrap align-center>
        <v-flex xs12 sm4 offset-sm4 xl4 offset-xl4 class="my-2">
          <div class="text-xd-center text-md-center login">
            <!-- <img src="/static/img/logo01.png" alt="Logo" class="mb-5"> -->
            
            <v-card class="elevation-12">
              <v-card-text style="padding: 50px 50px 50px 50px">  
                <v-form @submit.prevent="submit">
                  <!-- <h2 class="headline mb-0 text-xd-center text-md-center diarioobra"> <span class="diario">ABCobrança</span><br> </h2> -->
                  <img src="/static/img/logo.png" alt="Cobrança" height="100px" width="300px">
                  <h4 class="headline mb-0 text-xd-center text-md-center text-login">Log in</h4>
                  <v-flex xs12>
                    <v-layout row wrap >
                      <v-text-field
                        outlined
                        label="Usuário"
                        v-model="email"
                        append-icon="perm_identity"
                        class="input-login"
                        hide-details
                        :error-messages="emailErrors"
                        @input="$v.email.$touch()"
                        @blur="$v.email.$touch()"
                        required
                      ></v-text-field>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <v-layout row wrap >
                      <v-text-field
                        outlined
                        label="Senha"
                        type="password"
                        v-model="password"
                        append-icon="lock"
                        class="input-login"
                        hide-details
                        :error-messages="passwordErrors"
                        @input="$v.password.$touch()"
                        @blur="$v.password.$touch()"
                        v-on:keyup.enter="submit"
                        required
                      ></v-text-field>
                  
                    </v-layout>
                  </v-flex>
                </v-form>
              </v-card-text>
              <v-card-actions style="padding: 0px 50px 50px 50px;">
                <v-spacer></v-spacer>
                <v-btn color="primary" class="text-transform-none" @click="submit">Entrar</v-btn>
              </v-card-actions>
            </v-card>
          </div>
        </v-flex>
      </v-layout>
    </section>
    
  </div>
  
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import store from "../store";
import usuario from "@/services/usuario";

export default {
  name: 'Home',
  mixins: [validationMixin],
  data () {
    return {
      msg: 'Home',
      email: '',
      password: '',
      cards: {
        card1: "",
        card2: "",
        card3: ""
      }
    }
  },
  methods: {
    async submit () {
      this.$v.$touch()
      await this.$store.dispatch('signUserIn', {username: this.email, password: this.password})
      let res = await usuario.getUsuario(store.getters.user._id);
      
      this.$store.dispatch("SET_USUARIOS", res);
      if (res.acesso == "Cliente") {
        await this.$router.push('/recebimentos');
      } else if (res.acesso == "Admin") {
        await this.$router.push('/painel');
      } else if (res.acesso == "AdminClientes") {
        await this.$router.push('/painel');
      } else {
        await this.$router.push('/usuarios');
      }
    },
  }, 
  watch: {
    user (value) {
      /*if (value !== null && value !== undefined) {
        this.$router.push('/')
      }*/
    }
  },
  validations: {
    email: { required, email },
    password: { required }
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    emailErrors () {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.email && errors.push('Deve ser um e-mail válido')
      !this.$v.email.required && errors.push('Usuário deve ser informado')
      return errors
    },
    passwordErrors () {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.required && errors.push('Senha deve ser informada')
      return errors
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  html {
    font-family: Arial !important;
  }
  v-input {
    font-family: Arial !important;
  }
  .input-login {
    padding: 10px;
  }

  h1 {
    font-size: 40px !important;
    font-weight: 500;
  }
  h2 {
    font-weight: 500;
  }

  .v-card-title {
    font-weight: 600 !important;
    font-size: 35px !important;
  }

  .hr-title {
    border: none;
    border-top: 6px solid white;
    width: 150px;
    margin-top: 20px;
    margin-bottom: 10px;
  }

  .como-funciona {
    line-height: 0.5;
    text-align: center;
    font-weight: 500;
  }
  .como-funciona span {
    display: inline-block;
    position: relative;  
  }
  .como-funciona span:before,
  .como-funciona span:after {
    content: "";
    position: absolute;
    height: 5px;
    margin-top: 12px;
    border-bottom: 6px solid #00a99d;
    top: 0;
    width: 250px;
  }
  .como-funciona span:before {
    right: 100%;
    margin-right: 15%;
  }
  .como-funciona span:after {
    left: 100%;
    margin-left: 15%;
  }
  .login {
    margin-top: 60px;
  }
  .diarioobra {
    font-size: 40px !important;
    font-weight: 600;
    font-style: normal;
    
    margin-bottom: 20px !important;
  }
  .diario {
    color: #2088b4;
  }
  .text-login {
    font-size: 24px !important;
    font-weight: 600;
    padding: 10px 10px 30px 10px;
  }
  .icon-input {
    margin-top: 4px;
    background-color: #2088b4;
    width: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue